module.exports = __webpack_public_path__ + "static/img/SketchPng8b979f021ed4c4e5706d7703986a0d4357389fe1381df1e53299ac31c22bab9b.68ebf86d.png";